const Messages = {
  CONNECT: 'CONNECT',
  DISCONNECT: 'DISCONNECT',
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED',
  DATA_REQUEST: 'DATA_REQUEST',
  DATA_RESPONSE: 'DATA_RESPONSE',
  DATA_TRANSFER: 'DATA_TRANSFER',
  COMMAND_REQUEST: 'COMMAND_REQUEST',
  COMMAND_RESPONSE: 'COMMAND_RESPONSE'
}

export default Messages
